module.exports = __webpack_public_path__ + "img/album05_09.f03ba3cf.jpg";